import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackTranslationLanguageSelected.meta';

export type UseTrackTranslationLanguageSelectedParams = {
  target_language: string;
};

export const useTrackTranslationLanguageSelected = () => {
  const { track } = useAnalyticsUtilities();

  const trackTranslationLanguageSelected = useCallback(
    (params: UseTrackTranslationLanguageSelectedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackTranslationLanguageSelected };
};
